export const LABEL_TEXT = {
  welcome: "Welcome Aboard,",
  settings: "Manage My Account",
  lock: "Manage My Password",
  exit: "Logout",
  asdsAppName: "Software & Data Services (ASDS)",
  homeAppName: "MyAerospace Home",
  title: "Software & Data Services",
};

export const HEADER_URL = {
  aerospaceHome: "https://www.honeywellaerospace.com/en/myaerospace-home",
  myAccount: "https://www.honeywellaerospace.com/en/account",
  myPassword: "https://www.honeywellaerospace.com/en/account",
};
